import { Link } from 'react-router-dom';
import Button from '../../components/base/Button';
import { SEOHead } from '../../components/seo/SEOHead';

export default function HelpInstallPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white p-6">
      <SEOHead
        title="Como Instalar - Magistral"
        description="Instruções completas de como instalar o aplicativo Magistral no seu celular"
        robots="noindex, nofollow"
      />

      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-4 rounded-2xl overflow-hidden">
            <img
              src="/Imagens/logo magistral 2.0 verde.png"
              alt="Magistral"
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Instale o Magistral no seu celular
          </h1>
          <p className="text-gray-600">
            e tenha tudo organizado em um toque 💚
          </p>
        </div>

        <div className="bg-yellow-50 rounded-2xl border border-yellow-200 p-3 mb-6">
          <div className="flex items-start gap-3">
            <i className="ri-error-warning-line text-yellow-600 text-4xl mt-1"></i>
            <div>
              <h3 className="text-lg font-bold text-yellow-900 mb-2">
                Veio pelo Instagram?
              </h3>
              <p className="text-sm text-yellow-800 leading-relaxed mb-3">
                O navegador do Instagram não permite 
a instalação. Siga esses passos primeiro:
              </p>
              <ol className="text-sm text-yellow-800 space-y-1 list-decimal list-inside">
                <li>Toque no menu de opções (⋮ ou ⋯)</li>
                <li>Escolha "Abrir no Chrome" ou "Abrir no Safari"</li>
                <li>Depois siga as instruções abaixo</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Android */}
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <i className="ri-android-line text-green-600 text-2xl"></i>
            </div>
            <h2 className="text-2xl font-bold text-gray-800">Android</h2>
          </div>

          <ol className="space-y-4 text-gray-700">
            <li className="flex items-start gap-3">
              <span className="font-bold text-green-600 min-w-[24px]">1.</span>
              <span>Abra o site do Magistral no <strong>Chrome</strong> ou <strong>Samsung Internet</strong></span>
            </li>
            <li className="flex items-start gap-3">
              <span className="font-bold text-green-600 min-w-[24px]">2.</span>
              <span>Toque nos <strong>3 pontos verticais (⋮)</strong> no canto superior direito</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="font-bold text-green-600 min-w-[24px]">3.</span>
              <span>Selecione <strong>"Adicionar à tela inicial"</strong> ou <strong>"Instalar app"</strong></span>
            </li>
            <li className="flex items-start gap-3">
              <span className="font-bold text-green-600 min-w-[24px]">4.</span>
              <span>Confirme tocando em <strong>"Adicionar"</strong> ou <strong>"Instalar"</strong></span>
            </li>
          </ol>

          <div className="mt-4 bg-green-50 rounded-lg p-4 border border-green-200">
            <p className="text-sm text-green-800">
              ✅ Pronto! O ícone do Magistral aparecerá na sua tela inicial.
            </p>
          </div>
        </div>

        {/* iOS */}
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <i className="ri-apple-line text-blue-600 text-2xl"></i>
            </div>
            <h2 className="text-2xl font-bold text-gray-800">iPhone (iOS)</h2>
          </div>

          <ol className="space-y-4 text-gray-700">
            <li className="flex items-start gap-3">
              <span className="font-bold text-blue-600 min-w-[24px]">1.</span>
              <span>Abra o site do Magistral no <strong>Safari</strong></span>
            </li>
            <li className="flex items-start gap-3">
              <span className="font-bold text-blue-600 min-w-[24px]">2.</span>
              <span>
                Toque no botão{' '}
                <strong className="inline-flex items-center gap-1">
                  Compartilhar <i className="ri-share-2-line text-blue-600 text-lg" aria-hidden></i>
                </strong>{' '}
                na barra inferior
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="font-bold text-blue-600 min-w-[24px]">3.</span>
              <span>Role para baixo e escolha <strong>"Adicionar à Tela de Início"</strong></span>
            </li>
            <li className="flex items-start gap-3">
              <span className="font-bold text-blue-600 min-w-[24px]">4.</span>
              <span>Confirme o nome e toque em <strong>"Adicionar"</strong></span>
            </li>
          </ol>

          <div className="mt-4 bg-blue-50 rounded-lg p-4 border border-blue-200">
            <p className="text-sm text-blue-800">
              ✅ Pronto! O ícone do Magistral aparecerá na sua tela inicial.
            </p>
          </div>
        </div>

        {/* Botão Voltar */}
        <div className="text-center">
          <Link to="/">
            <Button variant="primary" className="px-8">
              <i className="ri-arrow-left-line mr-2"></i>
              Voltar para a página inicial
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
